<div class="container-fluid">
  <div class="mt-3">
  <button class="btn btn-soft sidebar-icon" (click)="openSidebar()"><i class="bi bi-list"></i></button>
  </div>

  <ng-content></ng-content>

  <hr class=" ms-3 me-3">
</div>

